// eslint-disable-next-line
import { plugin } from '@/services/index';
import pluginConst from '@/utils/const/plugin';

const { orderId, schemeId } = pluginConst;


export const SET_STEP = 'SET_STEP';
export const SET_DETAIL = 'SET_DETAIL';
export const SET_INTERFACE = 'SET_INTERFACE';

const state = {
  step: {
    // 后端返回值123, 以0触发调用接口
    [schemeId]: 0,
    [orderId]: 0,
  },
  detail: {
    [schemeId]: null,
    [orderId]: null,
  },
  interfaceInfo: {
    requestSchemeListUrl: '',
    requestCategoryUrl: '',
  },
};

const getters = {};

const mutations = {
  [SET_STEP](state, { pluginId, info }) {
    state.step[pluginId] = info;
  },
  [SET_DETAIL](state, { pluginId, info }) {
    state.detail[pluginId] = info;
  },
  [SET_INTERFACE](state, { info }) {
    state.interfaceInfo = info;
  },
};

const actions = {
  async getPluginInfo({ commit, state }, { pluginId, refresh = false }) {
    if (refresh || !state.step[pluginId]) {
      const { result: info } = await plugin.getAddInfo({ pluginId });
      commit(SET_STEP, { pluginId, info: info.step });
    }
  },
  async updatePluginInfo({ dispatch, commit }, { pluginId, step }) {
    const { result } = await plugin.updateStatus({ pluginId, step });
    if (result === true) {
      commit(SET_STEP, { pluginId, info: step });
      dispatch('updatePluginList');
    }
  },
  async getPluginOrderDetail({ commit, state }, refresh = false) {
    if (refresh || !state.detail[orderId]) {
      const { result: info } = await plugin.getOrderDetail();
      commit(SET_DETAIL, { pluginId: orderId, info });
    }
  },
  async getInterface({ commit, state }, refresh = false) {
    if (refresh || state.interfaceInfo.requestSchemeListUrl === '') {
      const { result = {} } = await plugin.getInterface();
      commit(SET_INTERFACE, { info: result });
    }
  },
};

export default {
  // namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
